
import { createContext, useContext, useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

type PlatformContextType = {
  isNativeApp: boolean;
  isMobileWeb: boolean;
  isDesktop: boolean;
};

const PlatformContext = createContext<PlatformContextType>({
  isNativeApp: false,
  isMobileWeb: false,
  isDesktop: true,
});

export const PlatformProvider = ({ children }: { children: React.ReactNode }) => {
  const [platform, setPlatform] = useState<PlatformContextType>({
    isNativeApp: false,
    isMobileWeb: false,
    isDesktop: true,
  });

  useEffect(() => {
    const detectPlatform = () => {
      const isNative = Capacitor.isNativePlatform();
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      
      const newPlatform = {
        isNativeApp: isNative,
        isMobileWeb: !isNative && isMobile,
        isDesktop: !isNative && !isMobile,
      };

      console.log('Platform Detection:', {
        userAgent: navigator.userAgent,
        windowWidth: window.innerWidth,
        isNative,
        isMobile,
        platform: newPlatform
      });

      setPlatform(newPlatform);
    };

    detectPlatform();
    window.addEventListener('resize', detectPlatform);
    
    return () => window.removeEventListener('resize', detectPlatform);
  }, []);

  return (
    <PlatformContext.Provider value={platform}>
      {children}
    </PlatformContext.Provider>
  );
};

export const usePlatform = () => {
  const context = useContext(PlatformContext);
  if (context === undefined) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
};
